<template>
  <transition name="fade-view" mode="out-in">
    <div v-if="view" class="loader-wrapper">
      <div class="preloader">
        <div class="lds-ring"><div /><div /><div /><div /></div>
        <div class="preloader-msg" v-html="setMsg" />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  props: {
    view: {
      type: Boolean,
      default: false
    },
    msg: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    setMsg() {
      return this.msg.msg
    },
    setInfo() {
      return this.msg.info
    }
  }
}
</script>

<style></style>
